export function pixelSizeHelper(
  designBaseFontSize: number,
  actualFontBaseSize: number
) {
  return (pixelSizeInDesign: number) =>
    Math.floor((pixelSizeInDesign / designBaseFontSize) * actualFontBaseSize);
}
